export type PublicationRestriction = {
  state: 'none' | 'timed' | 'manual_hold';
  restricted_until: string | null;
  manual_hold: boolean;
  active_violation_count: number;
  revision: number;
  latest_decision_id: string | null;
  server_time?: string;
};

export async function fetchPublicationRestriction(signal?: AbortSignal): Promise<PublicationRestriction> {
  const response = await fetch('/api/v1/me/moderation', {
    signal,
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(`Moderation state failed: ${response.status}`);
  const payload = await response.json() as { data: PublicationRestriction };
  return payload.data;
}

export function publicationRestrictionMessage(state: PublicationRestriction): string | null {
  if (state.state === 'manual_hold') {
    return 'Публикация фото и впечатлений ограничена до ручного решения модератора.';
  }
  if (state.state === 'timed' && state.restricted_until) {
    const date = new Date(state.restricted_until);
    const formatted = Number.isNaN(date.getTime())
      ? state.restricted_until
      : new Intl.DateTimeFormat('ru-RU', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        }).format(date);
    return `Публикация фото и впечатлений ограничена до ${formatted} из-за подтверждённого нарушения правил.`;
  }
  return null;
}

export function publicationDecisionUrl(state: PublicationRestriction): string {
  return state.latest_decision_id
    ? `/profile?moderation=${encodeURIComponent(state.latest_decision_id)}`
    : '/profile?section=xp';
}
